/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ShipmentLabelUpdateRequest = {
    name?: string | null;
    color?: ShipmentLabelUpdateRequest.color | null;
};
export namespace ShipmentLabelUpdateRequest {
    export enum color {
        PURPLE = 'purple',
        BLUE = 'blue',
        GREEN = 'green',
        ORANGE = 'orange',
        RED = 'red',
        GRAY = 'gray',
    }
}

